export default __webpack_public_path__ + "static/media/ic_arrow_prev_black.41251e86.svg";